import React from 'react';
import { Navigate } from 'react-router-dom';

export const PublicRoutes = ({ children, isLoggedIn, statusUser }) => {
  if (statusUser === 'register') {
    return children;
  }
  return !isLoggedIn ? children : <Navigate to='/' />;
};
